module.exports = __webpack_public_path__ + "static/media/demoOccasion.622bc531.png";